import React, { useContext, useEffect, useState } from "react";

import axios from "axios";
import StarProfileRightContent from "../../StarProfile/StarCardComponent/StarProfileRightContent/StarProfileRightContent";
import { Form, Spinner } from "react-bootstrap";
import ReactPlayer from "react-player";
import CostB from "../../../Assets/Images/BCost.png";
import swal from "sweetalert";
import { Markup } from "interweave";
import { useHistory } from "react-router-dom";
import NodataAvailable from "../../Common/NodataAvailable";
import { serverInfo } from "../../../App";
import { LocationContext } from "../../../CustomHelper/Helper";
import useProductImageHandleS3 from "../../../CustomHooks/useProductImageHandleS3";
import MediaUploadProgressBar from "../../../Screen/MediaUploadProgressBar";

const SouvenirRegister = ({ star_id }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [status, setStatus] = useState(true);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [posts, setPosts] = useState([]);
  const [openMessenger, setOpenMessenger] = React.useState(false);
  const [getSouviner, setGetSouviner] = useState({});
  const [souvinerId, setSouvinerId] = useState("");
  const [image, setImage] = useState("");
  const [showFile, setShowFile] = useState("");
  const [area, setArea] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [description, setDescription] = useState("");

  const history = useHistory();

  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const [deliverychargelist, setDeliveryChargeList] = useState([]);
  const [deliverychargeid, setDeliveryChargeId] = useState('');
  const [deliverycharge, setDeliveryCharge] = useState(0);

  const [newcountry, setNewCountry] = useState("");
  const [newstate, setNewState] = useState("");
  const [newcity, setNewCity] = useState("");

  const [errorList, setErrorList] = useState([]);

  const { slectedCurrency, payStatus } = useContext(LocationContext);
  const [countryBaseCost, setCountryBaseCost] = useState(false);

  useEffect(() => {

    axios.get("/api/user/souviner/view/" + star_id).then((res) => {
      if (res.data.status === 200) {
        setGetSouviner(res.data?.getSouviner);
        setSouvinerId(res.data?.getSouviner.id);
        setLoading(false);
      } else {
        // swal("error", "No Services!", "error");
        swal("Unavailable now", "Greetings Not Available Now", "warning");
      }
    });

    axios.get(`api/user/marketplace/view-country`).then((res) => {
      if (res.status === 200) {
        setCountry(res.data?.data);
        // setNewCountry(res.data.data);
      }
    });

    axios.get(`api/souvenirdeliverycharge`).then((res) => {
      if (res.status === 200) {
        setDeliveryChargeList(res.data.data);
      }
    });

  }, []);

  const handelCuntrybasePrice = (fee) => {
    return (
      (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0)
    );
  };

  const selectState = (e) => {
    let value = e.target.value;
    var data = value;

    axios.get(`/api/user/marketplace/state/${data}`).then((res) => {
      if (res.status === 200) {
        setState(res.data?.state);
      }
      // setLoading(false);
    });

    setNewCountry(data);
  };

  const selectCity = (e) => {
    let value = e.target.value;
    var data = value;

    axios.get(`/api/user/marketplace/city/${data}`).then((res) => {
      if (res.status === 200) {
        setCity(res.data?.city);
      }
      // setLoading(false);
    });

    setNewState(data);
  };
  const selectData = (e) => {
    let value = e.target.value;
    var data = value;
    setNewCity(data);
  };

  const selectDelivery =(e) =>{
    let data = deliverychargelist.find((item) => item.id == e.target.value);
    setDeliveryChargeId(data.id);
    setDeliveryCharge(data.courier_charge);
  }

  // File Handle Product Image
  const [productImage, setProductImage] = useState('');
  const [productImageDelKey, setProductImageDelKey] = useState(null);
  const [productImageUrl,productImageKey,progressBar] = useProductImageHandleS3(productImage, 'souvenir/images', productImageDelKey);

  const changeImage = (file) => {
    setProductImageDelKey(productImageKey);
    setProductImage(file[0]);
  };

  const createSouvenir = async (e) => {
    e.preventDefault();
    setLoader(true);
    const formData = new FormData();

    formData.append("souvinerId", souvinerId);
    formData.append("country_id", newcountry);
    formData.append("state_id", newstate);
    formData.append("city_id", newcity);
    formData.append("delivery_charge_id", deliverychargeid);
    formData.append("name", name);
    formData.append("mobile_no", mobileNo);
    formData.append("area", area);
    formData.append("description", description);
    formData.append("image", productImageKey);
    formData.append("password", password);

    await axios
      .post(`/api/user/souvenir/apply/store/` + star_id, formData)
      .then((res) => {
        setLoader(false);
        if (res.data.status === 200) {
          swal("Welcome", res.data.message, "success");
          history.push(`/starprofile/${star_id}`);
        } else if (res.data.status === 201) {
          swal("Unabailable Now", res.data.message, "warning");
        } else {
          setErrorList(res.data.validation_errors);
        }
      });
  };

  return (
    <div className="container StarContainer">
      <div className="row">
        {getSouviner.length !== 0 ? (
          <div className="col-md-8 mt-3 TabeStar">
            <div className="text-warning">
              <div className="card live-card-bg my-4 mx-auto">
                <div className="card-body">
                  <h5 className="card-title text-warning">
                    {getSouviner?.title}
                  </h5>
                </div>
              </div>
            </div>

            <div className="card live-card-bg my-4 mx-auto">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <h6 className="card-title text-info">
                    Souvenir Description
                  </h6>
                  {/* <p className="btn-warning btn-sm">Demo video</p> */}
                </div>
                <div className="star-line"></div>
                <p className="text-light mt-1">
                  <Markup content={getSouviner?.description} />
                </p>

                <div className="container-fluid my-2">
                  {loading === true ? (
                    <>
                      <h5 className="text-white justify-content-center text-center mx-auto souvinerStyle">
                        <div className="greetingsHeight d-flex justify-content-center align-items-center">
                          <Spinner
                            animation="border"
                            variant="warning"
                            className="souvinerStyle"
                            style={{
                              height: "100px",
                              width: "100px",
                              border: "10px dashed",
                            }}
                          />
                        </div>
                      </h5>
                    </>
                  ) : (
                    <img
                      src={
                        getSouviner?.banner
                          ? imageCdnUrl + getSouviner?.banner
                          : null
                      }
                      width="100%"
                      height="320px"
                      style={{ margin: "0 auto" }}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="text-warning">
              <div className="card live-card-bg my-4 mx-auto">
                <div className="card-body">
                  <h6 className="card-title text-info">
                    Souvenir Instructions
                  </h6>
                  <div className="star-line"></div>
                  <div className="text-light pt-2 instruct">
                    <Markup content={getSouviner?.instruction} />
                  </div>
                </div>
              </div>
            </div>

            <div className="card live-card-bg my-4 mx-auto">
              <div className="card-body">
                <h5 className="card-title text-warning">Cost</h5>
                <div className="star-line"></div>

                <img src={CostB} alt="" className=" Pods w-100 mt-2" />
                <div className="instruct PosImg">
                  <h6>Cost for the Souvenir:</h6>
                  <h6 className="text-light">
                    Price : {handelCuntrybasePrice(getSouviner?.price) +' '+slectedCurrency?.symbol}
                  </h6>
                  <h6 className="text-light">
                    Delivery Charge :{" "}
                    {handelCuntrybasePrice(deliverycharge)}{" "}
                    ---/--- Tax : {handelCuntrybasePrice(getSouviner?.tax) +' '+slectedCurrency?.symbol}
                    ---/--- Total : {Number(handelCuntrybasePrice(getSouviner?.price)) + Number(handelCuntrybasePrice(getSouviner?.tax)) + Number(handelCuntrybasePrice(deliverycharge)) +' '+slectedCurrency?.symbol}
                  </h6>
                </div>
              </div>
            </div>
            <div className="card live-card-bg my-4 mx-auto">
              <div className="card-body">
                <h5 className="card-title text-warning">Apply</h5>
                <div className="star-line"></div>
                <div className="instruct">
                  <form onSubmit={createSouvenir}>
                    <div className="row">
                      <div className="County mb-3 mt-3 col-md-6">
                        <h6 className="text-light">Country</h6>
                        <select
                          onChange={selectState}
                          aria-label="Default select example"
                          id="country_id"
                          name="country_id"
                          className="bg-dark border-0 InputSa form-control w-100"
                        >
                          <option className="text-whaite" value="">
                            --Choose Country--
                          </option>
                          {country.map((user, index) => (
                            <option className="text-whaite" value={user.id}>
                              {user.name}
                            </option>
                          ))}
                        </select>
                        <span className="text-danger">
                          {errorList.country_id}
                        </span>
                      </div>

                      <div className="County mb-3 mt-3 col-md-6">
                        <h6 className="text-light">State</h6>
                        <select
                          onChange={selectCity}
                          aria-label="Default select example"
                          id="state_id"
                          name="state_id"
                          className="bg-dark border-0 InputSa form-control w-100"
                        >
                          <option>--Select State--</option>
                          {state.map((user, index) => (
                            <option className="text-whaite" value={user.id}>
                              {user.name}
                            </option>
                          ))}
                        </select>
                        <span className="text-danger">
                          {errorList.state_id}
                        </span>
                      </div>

                      <div className="County mb-33 col-md-6">
                        <h6 className="text-light">City</h6>
                        <select
                          aria-label="Default select example"
                          onChange={selectData}
                          id="country_id"
                          name="country_id"
                          className="bg-dark border-0 InputSa form-control w-100"
                        >
                          <option>--Select City--</option>
                          {city.map((city, index) => (
                            <option className="text-whaite" value={city.id}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                        <span className="text-danger">{errorList.city_id}</span>
                      </div>

                      <div className="County mb-33 col-md-6">
                        <h6 className="text-light">Select Delivery Country</h6>
                        <select
                          aria-label="Default select example"
                          id="delivery_charge_id"
                          name="delivery_charge_id"
                          onChange={selectDelivery}
                          className="bg-dark border-0 InputSa form-control w-100"
                        >
                          <option>--Choose Delivery Country--</option>
                          {deliverychargelist.map((charge, index) => (
                            <option className="text-whaite" value={charge.id}>
                              {charge.country}
                            </option>
                          ))}
                        </select>
                        <span className="text-danger">{errorList.delivery_charge_id}</span>
                      </div>


                      <div className="County mb-33 col-md-6">
                        <h6 className="text-light">Name</h6>
                        <input
                          type="text"
                          onChange={(event) => {
                            setName(event.target.value);
                          }}
                          className="bg-dark border-0 InputSa form-control w-100"
                          placeholder=""
                        />
                        <span className="text-danger">{errorList.name}</span>
                      </div>

                      <div className="County mb-33 mt-3 col-md-6">
                        <h6 className="text-light">Mobile No</h6>
                        <input
                          type="number"
                          onChange={(event) => {
                            setMobileNo(event.target.value);
                          }}
                          className="bg-dark border-0 InputSa form-control w-100"
                          placeholder=""
                        />
                        <span className="text-danger">
                          {errorList.mobile_no}
                        </span>
                      </div>

                      <div className="County mb-33 mt-3 col-md-6">
                        <h6 className="text-light">Area</h6>
                        <input
                          type="text"
                          onChange={(event) => {
                            setArea(event.target.value);
                          }}
                          className="bg-dark border-0 InputSa form-control w-100"
                          placeholder=""
                        />
                        <span className="text-danger">{errorList.area}</span>
                      </div>
                    </div>

                    <label htmlFor="" className="labelSe my-2">
                      Short Description
                    </label>
                    <textarea
                      className="bg-dark border-0 InputSa form-control"
                      name=""
                      id=""
                      cols="30"
                      rows="5"
                      onChange={(event) => {
                        setDescription(event.target.value);
                      }}
                    ></textarea>
                    <span className="text-danger">{errorList.description}</span>

                    <label htmlFor="" className="labelSe my-2">
                      Upload Your Photo
                    </label>
                    <div>
                      <label
                        htmlFor="files"
                        className="btn text-light w-100 InputSa bg-dark"
                      >
                        <i className="fa-solid fa-cloud-arrow-up"></i> Upload
                      </label>
                      <input
                        id="files"
                        accept="image/*"
                        className="InputSas"
                        type="file"
                        onChange={(e) => changeImage(e.target.files)}
                      />
                      {productImage && !productImageUrl && <MediaUploadProgressBar progress={progressBar} />}
                      <span className="text-danger">{errorList.image}</span>
                      {productImageUrl ? (
                        <img
                          src={productImageUrl}
                          alt="..."
                          className="demo-preview-image mt-3"
                          style={{
                            border: "2px solid gold",
                            borderRadius: "23px",
                            height: "300px",
                            width: "100%",
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </div>

                    <label htmlFor="" className="labelSe my-2">
                      Password
                    </label>
                    <input
                      type="password"
                      onChange={(event) => {
                        setPassword(event.target.value);
                      }}
                      className="bg-dark border-0 InputSa form-control w-100"
                      placeholder="******"
                    />
                    <span className="text-danger">{errorList.password}</span>
                    <div className="d-flex justify-content-center mt-4 mb-3">
                      <button className="btn btn-register fw-bold  ">
                        {loader && (
                          <>
                            <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                          </>
                        )}
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-md-8 mt-3 TabeStar">
            <NodataAvailable className="mt-5" />
          </div>
        )}

        <div className="col-md-4  mt-3">
          <StarProfileRightContent star_id={star_id} />
        </div>
      </div>
    </div>
  );
};

export default SouvenirRegister;
